<template>
  <div class="relative pl-6 pr-10 py-4 mb-4 bg-red-100 border-l-4 border-red-500 p-4 pr-8 relative text-red-700" role="alert">

    <slot/>

    <button
      type="button"
      class="w-8 h-8 absolute right-2 top-1/2 transform -translate-y-1/2 flex items-center justify-center"
      aria-label="Close"
      @click="closeCallback"
    >
      <span class="sr-only">Close Alert</span>
      <svg class="w-3 h-3 pointer-events-none" fill="currentColor" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true"><path d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"></path></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'ErrorAlert',

  props: {
    closeCallback: {
      default: () => {},
      type: Function,
    },
  },
}
</script>
